// The confirm-registration dialog's words. PURE.
//
// ⚠️ THE DIALOG STATES WHAT THE COMMIT RE-CHECKS AND WHAT IT DOES NOT. The group
// ids are pinned (--expect-groups): if they changed since the preview, the run
// refuses and writes nothing. The CLUB list is re-read from GymSales at commit
// time, so a club added since the preview is included. That second sentence is
// the honest answer to "should a preview expire?": it doesn't, because the thing
// that could go wrongly stale (the tenant) is pinned, and the thing that can
// change (the roster) is re-read — and the reader is told so.

import type { RegistryResult } from './registryResult';

export interface ConfirmCopy {
  title: string;
  lead: string;
  notes: string[];
  button: string;
}

export function previewAge(finishedIso: string, nowMs: number): string {
  const t = Date.parse(finishedIso);
  if (!Number.isFinite(t)) return 'at an unknown time';
  const mins = Math.max(0, Math.round((nowMs - t) / 60_000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} minute${mins === 1 ? '' : 's'} ago`;
  const hours = Math.round(mins / 60);
  if (hours < 48) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  return `${Math.round(hours / 24)} days ago`;
}

export function confirmCopy(r: RegistryResult, previewFinishedIso: string, nowMs: number): ConfirmCopy {
  const n = r.groupNames.length;
  return {
    title: `Register clubs for these ${n} group${n === 1 ? '' : 's'}?`,
    lead: `This writes to the CRM registry. The preview you are confirming ran ${previewAge(previewFinishedIso, nowMs)} and listed ${r.clubs.length} club(s).`,
    notes: [
      'The group ids above are pinned: if the configuration has changed since the preview, the run refuses and writes nothing.',
      'The club list is read again from GymSales when this runs, so a club added since the preview will be registered too.',
      'A new club gets its first pull automatically on the next run. Clubs already registered keep their coverage.',
    ],
    button: `Register clubs (${n} group${n === 1 ? '' : 's'})`,
  };
}
